export default __webpack_public_path__ + "static/media/50-moon-min.fc8853f0.png";